import { UserType } from 'types';

export const isStaffUserType = (userType: UserType) =>
    userType === 'OWNER' || userType === 'EMPLOYEE';
